export default {
  DirectNumber: 'Direct',
  MainCompanyNumber: 'Main',
  CompanyNumber: 'Company',
  CompanyFaxNumber: 'Fax',
  Blocked: 'Blocked',
  AdditionalCompanyNumber: 'Company',
  ForwardedCompanyNumber: 'Forwarded',
  from: 'From',
} as const;
